import { render, staticRenderFns } from "./Ostan.vue?vue&type=template&id=e28f4456&scoped=true"
import script from "./Ostan.vue?vue&type=script&lang=js"
export * from "./Ostan.vue?vue&type=script&lang=js"
import style0 from "./Ostan.vue?vue&type=style&index=0&id=e28f4456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28f4456",
  null
  
)

export default component.exports